z<template>
    <div>
        <v-form ref="editForm" @submit.prevent>
            <v-card>
                <v-card-title>
                    <span class="headline">Delete OAuth Grants</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field v-model="oauthGrant.clientName" label="Client Name" :readonly="true" />
                    <date-time-field v-model="oauthGrant.createdAt" label="Created At" :readonly="true" />
                    <date-time-field v-model="oauthGrant.expiresAt" label="Expires At" :readonly="true" />
                </v-card-text>

                <v-card-actions>
                    <v-btn color="quaternary" text @click="cancel">Close</v-btn>
                    <div class="flex-grow-1"></div>
                    <v-btn color="quinary" text @click="deleteItem">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
    import axios from 'axios';
    import errorUtility from '../../services/errorUtility'

    export default {
        props: [
            'value'
        ],
        components: {
            dateTimeField: () => import('../../components/DateTimeField')
        },
        data() {
            return {
                apiMethod: 'OauthGrants',
            }
        },
        methods: {
            async deleteItem() {
                if (this.isDeleting) { return; }
                if (confirm("Are you sure you want to delete this OAuth Grant?")) {
                    this.isDeleting = true;
                    try {
                        await axios.delete('/api/' + this.apiMethod + '/' + this.oauthGrant.id);
                    } catch (error) {
                        this.$emit('open');
                        errorUtility.handleServerError(error);
                    }
                    finally {
                        this.isDeleting = false;
                    }
                    this.$emit('input', this.oauthGrant);
                    this.$emit('delete', this.oauthGrant);
                }
            },
            async cancel() {
                this.$emit('close');
                this.$emit('cancel');
            },
        },
        computed: {
            oauthGrant() {
                if (this.value !== null && typeof this.value !== "undefined") {
                    return this.value;
                }
                return {};
            }
        }
    };
</script>
